/**
 * Доступ к стору и роутеру из кода, который живёт вне компонентов Vue.
 *
 * Трекеры аналитики обращались к ним через `window.Vue.prototype.$store`
 * и `window.Vue.prototype.$router`. Не работало ни то, ни другое:
 *
 *   1. `window.Vue` в проекте не присваивается нигде, поэтому каждая такая
 *      проверка была ложной, а весь код за ней — мёртвым.
 *
 *   2. Присвоить `window.Vue = Vue` и тем «починить» нельзя. Vuex не кладёт
 *      `$store` на прототип: он ставит его на каждый экземпляр миксином
 *      beforeCreate. А vue-router объявляет `$router` геттером
 *      `this._routerRoot._router` — чтение его на самом прототипе, где
 *      `_routerRoot` нет, бросает TypeError. То есть попытка оживить старую
 *      конструкцию превратила бы тихо мёртвый код в падение.
 *
 * Поэтому main.js кладёт стор и роутер сюда явно, а потребители спрашивают
 * их через эти функции.
 */

const HANDLE = '__karbosnabApp';

/**
 * Вызывается один раз при старте приложения.
 */
export function registerApp({store, router}) {
    if (typeof window === 'undefined') {
        return;
    }

    window[HANDLE] = {store, router};
}

/**
 * @returns {object|null} стор Vuex или null, если приложение ещё не стартовало
 */
export function getStore() {
    if (typeof window === 'undefined') {
        return null;
    }

    return (window[HANDLE] && window[HANDLE].store) || null;
}

/**
 * @returns {object|null} роутер или null, если приложение ещё не стартовало
 */
export function getRouter() {
    if (typeof window === 'undefined') {
        return null;
    }

    return (window[HANDLE] && window[HANDLE].router) || null;
}
